import router, { asyncRoutes, constantRoutes } from '@/router'

const hasPermission = (roles, route) => {
  if (route.meta && route.meta.roles) {
    return roles.some((role) => route.meta.roles.includes(role))
  }
  return true
}

const permission = {
  state: {
    routes: [],
    addRoutes: []
  },

  getters: {
    permissionRoutes: (state) => state.routes,
    addRoutes: (state) => state.addRoutes
  },

  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    }
  },

  actions: {
    InitRoutes: async({ commit }, { roles }) => {
      try {
        let accessedRoutes
        if (roles.includes('admin')) { accessedRoutes = asyncRoutes } else { accessedRoutes = filterAsyncRoutes(roles, asyncRoutes) }
        commit('SET_ROUTES', accessedRoutes)
      } catch (err) {
        console.error(err)
      }
    }
  }
}

export default permission
